/** Prefixes CBDA puts on its enum values, e.g. HW_SUB_TYPE_WING_R24_VECTOR or MAINTENANCE_EVENT_PROPELLER_REPLACEMENT. */
const CBDA_PREFIX_PATTERN =
  /^((MAINTENANCE_)?HW_(SUB_)?TYPE_|MAINTENANCE_(ENTRY|EVENT)_|COUNTER_TYPE_)/;

/** Tokens that stay in upper case because they are acronyms rather than words. */
const KEPT_UPPERCASE_TOKENS = new Set(['AI', 'ADSB', 'ESC']);

/**
 * Turns an enum value into a readable label, e.g. 'HW_SUB_TYPE_WING_R24_VECTOR' -> 'Wing R24 Vector',
 * 'left_wing' -> 'Left Wing', 'totalTime' -> 'Total Time'. Tokens containing a digit and known
 * acronyms stay upper case.
 */
export function humanizeEnumValue(value?: string, fallback = ''): string {
  const trimmed = value?.trim();
  if (!trimmed) {
    return fallback;
  }

  const words = /^[a-z][a-zA-Z\d]*$/.test(trimmed)
    ? trimmed.replace(/([a-z\d])([A-Z])/g, '$1 $2')
    : trimmed.replace(CBDA_PREFIX_PATTERN, '');

  return words
    .split(/[_\s]+/)
    .filter(Boolean)
    .map(formatToken)
    .join(' ');
}

function formatToken(token: string): string {
  const upperCaseToken = token.toUpperCase();

  if (/\d/.test(token) || KEPT_UPPERCASE_TOKENS.has(upperCaseToken)) {
    return upperCaseToken;
  }

  return upperCaseToken.charAt(0) + upperCaseToken.slice(1).toLowerCase();
}
